import { createUnauthenticatedAxiosClient } from '../api/axiosClient';
import { ReferrerData } from '../utils/utmTracking';

const unauthClient = createUnauthenticatedAxiosClient();

/**
 * Notify the backend that a user started the signup flow.
 * Fire-and-forget — errors are silently caught so they never block the Auth0 redirect.
 */
export const trackSignupStarted = (
  email: string,
  anonymousId: string,
  referrerData: ReferrerData | null
): void => {
  const attribution = referrerData
    ? {
        utm_source: referrerData.utmSource,
        utm_medium: referrerData.utmMedium,
        utm_campaign: referrerData.utmCampaign,
        utm_term: referrerData.utmTerm,
        utm_content: referrerData.utmContent,
        referrer: referrerData.referrer,
        gclid: referrerData.gclid,
      }
    : undefined;

  unauthClient
    .post('/analytics/signup-started', {
      email,
      anonymous_id: anonymousId,
      attribution,
    })
    .catch(() => {
      // Silently swallow — signup flow must never be blocked by analytics
    });
};
